import { render, staticRenderFns } from "./JdsTableRow.vue?vue&type=template&id=2cf04293&scoped=true&"
import script from "./JdsTableRow.vue?vue&type=script&lang=ts&"
export * from "./JdsTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./JdsTableRow.vue?vue&type=style&index=0&id=2cf04293&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf04293",
  null
  
)

export default component.exports